import { _ as _defineProperty } from '../../defineProperty-18999f8e.js';
import { p as getNodeAttrs } from '../../selectors-f64b5778.js';
import { hasHorizontalScroll, hasVerticalScroll } from '../hasScroll/index.js';
import '../../typeof-92b42de1.js';
import '../../slicedToArray-26803f33.js';
import '../../unsupportedIterableToArray-577176bf.js';
import '../../toConsumableArray-2a2700d9.js';
import '../../configs/index.js';
import '../calculateCanvasHeight/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var calcStagePosition = function calcStagePosition(stage, hasVerticalScrollParams) {
  var ignoreScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var _getNodeAttrs = getNodeAttrs(stage),
      scaleX = _getNodeAttrs.scaleX,
      x = _getNodeAttrs.x,
      y = _getNodeAttrs.y;

  return {
    x: ignoreScroll !== hasHorizontalScroll(scaleX) ? 0 : x,
    y: ignoreScroll !== hasVerticalScroll(_objectSpread(_objectSpread({}, hasVerticalScrollParams), {}, {
      zoom: scaleX
    })) ? 0 : y
  };
};

export { calcStagePosition as default };
